module.exports = __webpack_public_path__ + "image/Transeagle_2.png";